module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/profile/profile.component.scss
// module id = ./src/app/entities/profile/profile.component.scss
// module chunks = main